export const getToken = () => localStorage.getItem('Authorization');
export const setToken = (token) => localStorage.setItem('Authorization', token);
export const deleteToken = () => localStorage.setItem('Authorization', undefined);

export const setUserDetails = (userDetails) => localStorage.setItem('userDetails', userDetails);
export const getUserDetails = () => localStorage.getItem('userDetails');
export const deleteUserDetails = () => localStorage.setItem('userDetails', undefined);
